import { ColorConf } from "@/config/color";
import { Month, Network, PaymentMethod } from "@/types/plan";
import { UserPlan } from "@/types/userPlan";
import { CSSProperties } from "react";

export const NAVBAR_LINK = {
  signUp: "/signUp",
  signIn: "/signIn",
  home: "/home",
  boards: "/boards",
  dateRecruitment: "/dateRecruitment",
  timeline: "/timeline",
  chats: "/chats",
  mypage: "/mypage",
  defaultPage: "/",
  user: "/user",
  _user: "/_user",
  searchEdit: "/searchEdit",
  settings: "/settings",
  termsOfService: "/termsOfService",
  privacyPolicy: "/privacyPolicy",
  deletionSuccess: "/deletionSuccess",
  faq: "/faq",
  createNewPassword: "/createNewPassword",
  resetPassword: "/resetPassword",
  ageVerification: "/ageVerification",
  whitePaper: "/whitePaper",
  plans: "/plans",
  desireSetting: "/desireSetting",
  search: "/search",
  profileSetting: "/profileSetting",
  desire: "/desire",
  chat: "/chat",
  notFound: "/notFound",
  snsAccounts: "/snsAccounts",
  emailAction: "/emailAction",
  contact: "/contact",
  stdVerification: "/stdVerification",
  userWoman: "/userWoman",
  claimedVerificationCampaign: "/claimedVerificationCampaign"
};

export const PUBLIC_PATHS = [
  NAVBAR_LINK.defaultPage,
  NAVBAR_LINK.signIn,
  NAVBAR_LINK.signUp,
  NAVBAR_LINK.termsOfService,
  NAVBAR_LINK.privacyPolicy,
  NAVBAR_LINK.createNewPassword,
  NAVBAR_LINK.resetPassword,
  NAVBAR_LINK.faq,
  NAVBAR_LINK.deletionSuccess,
  NAVBAR_LINK.notFound,
  NAVBAR_LINK.emailAction,
  NAVBAR_LINK.contact,
  "/installPWA"
];

export const USER_DETAIL_PATH = "/user/[uid]";
export const CHAT_DETAIL_PATH = "/chat/[id]";

export const DEFAULT_MEMBER_IMG = "/images/no-image.svg";

export const IMAGE_100_OPTIONS: CSSProperties = {
  height: 100,
  width: 100,
  borderRadius: 20,
  objectFit: "cover",
  // ref: https://techblog.yahoo.co.jp/entry/2020090830016393/
  contentVisibility: "auto"
};

export const IMAGE_OPTIONS: CSSProperties = {
  borderRadius: 20,
  // MEMO: アイコン画像を表示する時のおきて
  height: 300,
  width: 300,
  objectFit: "cover",
  marginLeft: "auto",
  marginRight: "auto",
  // ref: https://techblog.yahoo.co.jp/entry/2020090830016393/
  contentVisibility: "auto"
};

export const DEFAULT_TW_URL = "https://twitter.com";

export const ID_VERIFICATION_STATUS = {
  pending: "pending",
  rejected: "rejected",
  verified: "verified"
};

export const USER_SEX = {
  female: "female",
  male: "male"
};

export const USER_TYPE: { [key: string]: "UserWomen" | "UserMen" } = {
  female: "UserWomen",
  male: "UserMen"
};

export const CONTENT_OPTIONS: string[] = [
  "健全デートから",
  "カフェで待ち合わせ",
  "ご飯から",
  "直ホで"
];

export const QUERY_KEYS = {
  timeline: "timeline",
  recruitment: "recruitment"
};

export const RECRUITMENT_TABS: { [key: number]: string } = {
  0: "bulletinBoard",
  1: "myself"
};

export const TIMELINE_TABS: { [key: number]: string } = {
  0: "recommend",
  1: "like",
  2: "filter"
};

export const USER_STATUS = {
  deleted: "deleted",
  active: "active"
};

export const DELETED_NAME = "退会したユーザー";

export const PHOTO_KEYS: { [key: number]: string } = {
  2: "photoURLSecond",
  3: "photoURLThird",
  1: "photoURL"
};

export const ICON_TYPES: { [key: number]: "default" | "second" | "third" } = {
  2: "second",
  3: "third",
  1: "default"
};

export const ERROR_STYLE = {
  color: ColorConf.Error100,
  fontWeight: "bold"
};

export const NORMAL_TEXT = {
  color: "inherit",
  fontWeight: "normal"
};

export const SNS_KEYS = {
  twitter: "twitter",
  instagram: "instagram",
  tiktok: "tiktok",
  password: "password"
};

export const MAX_BADGE_COUNT = 9;

export const MAX_SIZE_IMAGE = 10;
export const MAX_SIZE_FILE = 10;

export const ID_IMAGE_ALLOWED_TYPES = [
  "image/jpeg",
  "image/jpg",
  "image/png",
  "image/webp"
];

export const ID_IMAGE_SPECIAL_TYPES = [
  "image/heic",
  "image/heif",
  "image/heif-sequence"
];

export const ID_FILE_ALLOWED_TYPES = ["application/pdf"];

export const MAX_TOTAL_SIZE_INQUIRY = 20;

export const MAX_FILES_INQUIRY = 5;

export const STD_LINK = "https://std-1.uraharu.xyz/";

export const MARK_STATUS = {
  seen: "seen",
  sent: "sent"
};

export const DATE_FORMATS = {
  HOUR_AND_MINUTE: "HH:mm",
  YEAR_MONTH_DATE: "yyyy-MM-dd",
  SHORT_YEAR_MONTH_DATE: "yyyy/MM/dd",
  FULL_DATE_MONTH_YEAR: "dd/MM/yyyy",
  JP_DATE: "yyyy年MM月dd日"
};

export const FIREBASE_COLLECTION_NAME = {
  chats: "Chats",
  likes: "LikedList",
  rejects: "RejectList",
  recommends: "RecommendList",
  members: "Members",
  men: "UserMen",
  women: "UserWomen",
  fancloveMember: "FancloveMembers"
};

export const SUBSCRIPTION_NAME_PLANS = {
  ベーシックプラン: "basic",
  スタンダードプラン: "standard",
  プレミアムプラン: "premium"
};

export const DAY_PERIOD = 30;

export enum Permission_Notification {
  Default = "default",
  Granted = "granted",
  Denied = "denied"
}

export const FCM_NAVIGATE_KEY: Record<string, string> = {
  chat: "chat",
  chats: "chats",
  plans: "plans",
  dateRecruitment: "dateRecruitment"
};

export enum Actor {
  Woman = "woman",
  Man = "man"
}

export const BLOCKED_PAGES_USE_SWIPE_BACK = [
  NAVBAR_LINK.chat,
  NAVBAR_LINK.home
];

export const SWIPE_BACK_OPTIONS = {
  threshold: 100,
  edgeZone: 50,
  velocityThreshold: 0.3,
  maxVerticalMovement: 75,
  edgeThreshold: 50,
  disabled: false
};

export const DESIRE_RELATED_PATHS: string[] = [
  NAVBAR_LINK.desireSetting,
  NAVBAR_LINK.desire
];

export enum STORAGE_KEY {
  IS_REQUEST_FIRST_TIME = "isRequestFirstTime",
  UID = "uid",
  LAST_RECOMMEND_CHECKED_AT = "lastRecommendCheckedAt",
  BANNER_INSTALL_PWA = "bannerInstallPWA",
  SKIP_NEW_ONBOARDING = "skipNewOnboarding",
  NEW_PROFILE = "newProfile",
  CLAIMED_BASIC_PLAN_FREE = "claimedBasicPlanFree"
}

export const PERSIST_KEYS: string[] = [STORAGE_KEY.CLAIMED_BASIC_PLAN_FREE];

export enum Platform {
  Ios = "ios",
  Android = "android",
  DesktopSafari = "DesktopSafari",
  Desktop = "desktop"
}

export enum Browser {
  Chrome = "chrome",
  Safari = "safari"
}

export const UPDATE_NOT_REFLECTED_STEPS = [
  "アプリを完全に閉じて再度開いてください。",
  "Androidの場合：サイトストレージをクリアしてください。",
  "iOSの場合：Safariから再インストールしてください。"
];

export const ICON_NOT_APPEARING_STEPS = [
  "アプリを削除して再インストールしてください。",
  "アイコンの更新には時間がかかる場合がありますので、数分待ってください。"
];

export const ADD_TO_HOME_SCREEN_HELP = [
  "Safari（iOS）またはChrome（Android）を使用してください。",
  "プライベートモードやシークレットモードではないことを確認してください。"
];

export const NOTES = [
  {
    title: "「ホーム画面に追加」または「アプリをインストール」が表示されない",
    notices: ADD_TO_HOME_SCREEN_HELP
  },
  {
    title: "アイコンが正しく表示されない",
    notices: ICON_NOT_APPEARING_STEPS
  },
  {
    title: "更新が反映されない",
    notices: UPDATE_NOT_REFLECTED_STEPS
  }
];

export const ENABLE_NOTI_IOS = [
  {
    description:
      "ホーム画面からウラハルを開き、表示されたら「許可」をタップします。",
    image: "/images/open-app-tap-allow-ios.png"
  },
  {
    description:
      "プロンプトを見逃した場合：設定 → 通知 → ウラハル → 通知を許可に進んでください。",
    image: "/images/settings-allow-notifications-ios.png"
  }
];

export const ENABLE_NOTI_ANDROID = [
  {
    description: "表示されたら、「許可」をタップします。",
    image: "/images/open-app-tap-allow-android.png"
  },
  {
    description:
      "または手動で設定 → アプリ → ウラハル → 通知 → 有効に進んでください。",
    image: "/images/settings-allow-notifications-android.png"
  }
];

export const ENABLE_NOTIFICATIONS = [
  { title: "iOS（Safari）", descriptions: ENABLE_NOTI_IOS },
  { title: "Android（Chrome）", descriptions: ENABLE_NOTI_ANDROID }
];

export const URAHARU_DOMAIN = "https://uraharu.xyz";

export const STEP_1_IOS = [
  {
    title: "Safari",
    img: "/images/safari-step-1.png"
  },
  {
    title: "Chrome",
    img: "/images/chrome-step-1.png"
  }
];

export type PlatformType =
  | Platform.Android
  | Platform.Desktop
  | Platform.Ios
  | Platform.DesktopSafari;

export enum MESSAGE_TYPE {
  NAVIGATE_TO = "NAVIGATE_TO",
  NOTIFICATION_RECEIVED = "NOTIFICATION_RECEIVED"
}

export const IOS_LIQUID_GLASS_VERSION = 26;

export const MONTHS: Month[] = [
  {
    title: "1ヶ月",
    description: "月",
    monthNo: 1,
    discount: 0,
    fontSize: "",
    background: `linear-gradient(264deg, ${ColorConf.TertiaryForWomen} 0%, ${ColorConf.PrimaryForWomen} 100%)`,
    periodId: "oneMonth"
  },
  {
    title: "3ヶ月",
    description: "3ヶ月",
    monthNo: 3,
    discount: 10,
    fontSize: "11px",
    background: `linear-gradient(264deg, ${ColorConf.TertiaryForWomen} 0%, ${ColorConf.PrimaryForWomen} 100%)`,
    periodId: "threeMonths"
  },
  {
    title: "6ヶ月",
    description: "6ヶ月",
    monthNo: 6,
    discount: 15,
    fontSize: "12px",
    background: `linear-gradient(264deg, ${ColorConf.TertiaryForWomen} 0%, ${ColorConf.PrimaryForWomen} 100%)`,
    periodId: "sixMonths"
  },
  {
    title: "1年",
    description: "年",
    monthNo: 12,
    discount: 25,
    fontSize: "14px",
    background: `linear-gradient(264deg, ${ColorConf.Accent100} 0%, ${ColorConf.PrimaryForWomen} 100%)`,
    periodId: "oneYear"
  }
];

export const RECOMMEND_PLANS: Record<string, { plan: UserPlan; img: string }> =
  {
    oneMonth: {
      plan: UserPlan.Standard,
      img: "/images/recommend-plan-1-month.svg"
    },
    oneYear: {
      plan: UserPlan.Premium,
      img: "/images/recommend-plan-1-year.svg"
    }
  };

export const PeriodHasFreePlan = ["oneMonth"];

export enum ORDER_STATUS {
  PENDING = "pending",
  PAID = "paid",
  CONFIRMED = "confirmed",
  EXPIRED = "expired",
  CANCELLED = "cancelled",
  FAILED = "failed"
}

export const NETWORKS: Record<number, Network> = {
  97: {
    name: "BNB Smart Chain Testnet",
    image: "/images/payment/bsc.svg"
  },
  137: {
    name: "Polygon",
    image: "/images/payment/polygon.svg"
  }
};

export enum ACTION {
  UPGRADE = "upgrade",
  CANCEL = "cancel",
  NEXT = "next",
  REFRESH_PAYMENT = "refresh_payment",
  CONFIRM = "confirm",
  PAY = "pay",
  NEW = "new",
  ADD = "add",
  REMOVE = "remove"
}

export const planTexts: { [key: string]: string } = {
  free: "フリー",
  basic: "べーシック",
  standard: "スタンダード",
  premium: "プレミアム"
};

export const PAYMENT_EXPIRATION_MINUTES = 30;

export const DECIMALS: Record<number, Record<string, number>> = {
  97: {
    JPYC: 18
  },
  137: {
    JPYC: 18
  }
};

export const PRIORITY_PLANS = {
  [UserPlan.Free]: 0,
  [UserPlan.Basic]: 1,
  [UserPlan.Standard]: 2,
  [UserPlan.Premium]: 3
};

export const QUERY_CACHE_OPTIONS = {
  NO_CACHE: {
    gcTime: 0,
    refetchOnMount: "always",
    refetchOnWindowFocus: true,
    refetchOnReconnect: "always",
    staleTime: 0
  }
} as const;

export const Default_Entries = 40;

export const SUPPORT_WALLETS = ["MetaMask", "Avacus"];

export enum PAYMENT_METHOD {
  FANCLOVE = "fanclove",
  BLOCKCHAIN = "blockchain",
  CREDIX = "credix",
  PAIDY = "paidy"
}

enum PAYMENT_METHOD_DESCRIPTION {
  FANCLOVE = "レガシー方式 <br /> アプリは不要",
  BLOCKCHAIN = "より速く、<br /> より安く",
  CREDIX = "クレジットカード (VISA, MasterCard, JCB, Diners, AMEX)",
  PAIDY = "後払い"
}

export const HYBRID_PAYMENT = "hybridPayment";

const DEFAULT_ENABLED_PAYMENT_METHODS = Object.values(PAYMENT_METHOD);

const DEFAULT_PAYMENT_METHOD_BADGES = [
  PAYMENT_METHOD.BLOCKCHAIN,
  PAYMENT_METHOD.CREDIX,
  PAYMENT_METHOD.PAIDY
];

const parsePaymentMethodEnv = (
  value: string | undefined,
  defaultValues: PAYMENT_METHOD[]
): PAYMENT_METHOD[] => {
  const trimmedValue = value?.trim();
  if (!trimmedValue) return defaultValues;

  const parsedMethods = trimmedValue
    .split(",")
    .map((method) => method.trim())
    .filter((method): method is PAYMENT_METHOD =>
      Object.values(PAYMENT_METHOD).includes(method as PAYMENT_METHOD)
    );

  return parsedMethods.length > 0 ? parsedMethods : defaultValues;
};

const enabledPaymentMethods = parsePaymentMethodEnv(
  process.env.NEXT_PUBLIC_ENABLED_PAYMENT_METHODS,
  DEFAULT_ENABLED_PAYMENT_METHODS
);

const paymentMethodBadges = parsePaymentMethodEnv(
  process.env.NEXT_PUBLIC_PAYMENT_METHOD_BADGES,
  DEFAULT_PAYMENT_METHOD_BADGES
);

const isPaymentMethodEnabled = (method: PAYMENT_METHOD): boolean =>
  enabledPaymentMethods.includes(method);

const hasPaymentMethodBadge = (method: PAYMENT_METHOD): boolean =>
  paymentMethodBadges.includes(method);

const COMING_SOON_TEXT = "近日公開";

const PAYMENT_METHOD_DESCRIPTIONS: Record<
  PAYMENT_METHOD,
  PAYMENT_METHOD_DESCRIPTION
> = {
  [PAYMENT_METHOD.FANCLOVE]: PAYMENT_METHOD_DESCRIPTION.FANCLOVE,
  [PAYMENT_METHOD.BLOCKCHAIN]: PAYMENT_METHOD_DESCRIPTION.BLOCKCHAIN,
  [PAYMENT_METHOD.CREDIX]: PAYMENT_METHOD_DESCRIPTION.CREDIX,
  [PAYMENT_METHOD.PAIDY]: PAYMENT_METHOD_DESCRIPTION.PAIDY
};

const getPaymentMethodDescription = (method: PAYMENT_METHOD): string =>
  isPaymentMethodEnabled(method)
    ? PAYMENT_METHOD_DESCRIPTIONS[method]
    : COMING_SOON_TEXT;

export const PAYMENT_METHOD_LIST: Record<string, PaymentMethod> = {
  [PAYMENT_METHOD.FANCLOVE]: {
    img: "/images/payment/legacy-payment.png",
    description: getPaymentMethodDescription(PAYMENT_METHOD.FANCLOVE),
    enable: isPaymentMethodEnabled(PAYMENT_METHOD.FANCLOVE)
  },
  [PAYMENT_METHOD.BLOCKCHAIN]: {
    img: "/images/payment/jpyc-payment.png",
    description: getPaymentMethodDescription(PAYMENT_METHOD.BLOCKCHAIN),
    enable: isPaymentMethodEnabled(PAYMENT_METHOD.BLOCKCHAIN),
    hasBadge: hasPaymentMethodBadge(PAYMENT_METHOD.BLOCKCHAIN)
  },
  [PAYMENT_METHOD.CREDIX]: {
    img: "/images/payment/credix-payment-2.png",
    description: getPaymentMethodDescription(PAYMENT_METHOD.CREDIX),
    enable: isPaymentMethodEnabled(PAYMENT_METHOD.CREDIX),
    hasBadge: hasPaymentMethodBadge(PAYMENT_METHOD.CREDIX)
  },
  [PAYMENT_METHOD.PAIDY]: {
    img: "/images/payment/paidy-payment-2.png",
    description: getPaymentMethodDescription(PAYMENT_METHOD.PAIDY),
    enable: isPaymentMethodEnabled(PAYMENT_METHOD.PAIDY),
    hasBadge: hasPaymentMethodBadge(PAYMENT_METHOD.PAIDY)
  }
};

export const PERIOD_FANCLOVE = ["oneMonth"];

export const NEW_USER_HOURS = Number(
  process.env.NEXT_PUBLIC_NEW_USER_HOURS ?? 48
);
export const MAX_DISPLAY_NAME = 10;
